import React from "react";
import "./LogoSlider.css";

const logos = [
  { name: "AFI", src: "/assets/logo/afi.png" },
  { name: "AFI 2", src: "/assets/logo/afi2.png" },
  { name: "BOB", src: "/assets/logo/bob.png" },
  { name: "FOD", src: "/assets/logo/fod.png" },
  { name: "RIDE", src: "/assets/logo/ride.png" },
];

const LogoSlider = () => {
  const sliderLogos = [...logos, ...logos];

  return (
    <section className="logo-slider-section">
      <div className="container">
        <div className="logo-slider-heading">
          <h2 className="logo-slider-heading-title">Our Clients:</h2>
          <p className="logo-slider-heading-subtitle">
            Expertise that delivers — for every client we serve.
          </p>
        </div>

        <div className="logo-slider-wrapper">
          <div className="logo-slider-track">
            {sliderLogos.map((logo, index) => (
              <div className="logo-slider-item" key={`${logo.name}-${index}`}>
                <img src={logo.src} alt={logo.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;